import StyledBackdrop from './Backdrop.styles';

export const Backdrop = StyledBackdrop;

Backdrop.displayName = 'Backdrop';
